import { setUserTimezoneInLocalStorage } from 'applicaiton/sessionStorage/auth';
import { setTimeZone } from 'applicaiton/store/reducers/TimeZone/TimeZoneSlice';

import { useAppDispatch, useAppSelector } from './redux';
import { setTimeZoneData } from 'applicaiton/store/reducers/TimeZone/ActionCreators';

/**
 * A custom hook that provides functionality to set and retrieve a user's timezone.
 */
export const useUserTimeZone = () => {
  const dispatch = useAppDispatch();
  const { tz } = useAppSelector((state) => state.timeZone);

  /**
   * A function that sets a new user timezone and updates the Redux store and local storage accordingly.
   *
   * @param value - The new timezone value to set.
   */
  const setUserTimeZone = (value: string) => {
    dispatch(setTimeZoneData(value)).then((data) => {
      if (data.meta.requestStatus === 'fulfilled') {
        dispatch(setTimeZone(value));
        setUserTimezoneInLocalStorage(value);
      }
    });
  };

  return { tz, setUserTimeZone };
};
